module.exports = __webpack_public_path__ + "img/fjollaName.d9076e44.svg";